import React, { Component, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Loading from '../../components/Loading';
import ModalAlert from '../../components/ModalAlert';
import crmservices from '../../wsclient/';
import MobilePassCardView from './MobilePassCardView';

function MobilePassCardController(props){
    const [showLoading, onShowLoading] = useState(false);
    const [error, setError] = useState({
        showAlert: false,
        title: '',
        message: '',
        status: '',
    });
    const [urlGooglePay, setUrlGooglePay] = useState('');
    const [urlAppleWallet, setUrlAppleWallet] = useState('');
    const [urlAndroidWallet, setUrlAndroidWallet] = useState('');
    const { t } = useTranslation();

    useEffect(()=>{
        onLoad();
    },[]);
    const onLoad = async() =>{
        await getApplePass();
        await getGooglePass();
        await getAndroidWalletPass();
    }

    const showAlert = (status, message, title) =>{
        onShowLoading(false);
        setError({
            showAlert: true,
            title: title,
            message: message,
            status: status,
        });
    }
    const onCloseAlert = async() =>{
        onShowLoading(false);
        setError({
            showAlert: false,
            title: '',
            message: '',
            status: '',
        });
    }

    const getApplePass = async() =>{
        onShowLoading(true);
        try {
            var result = await crmservices.contacts.getApplePass();
            if (result.code === 'OK') {
                console.log("getApplePass result===", result);
                if(result.data){
                    setUrlAppleWallet(result.data);
                }else{
                    showAlert(true, t('file_pkpass_not_found'), t('mobile_pass_card'));
                }
            }
        } catch (error) {
            showAlert(true, t('EXCEPTION_PROCESS'), t('ERROR'));
        }
        onShowLoading(false);
    }
    const getAndroidWalletPass = async() =>{
        onShowLoading(true);
        try {
            var result = await crmservices.contacts.getAndroidWalletPass();
            if (result.code === 'OK') {
                console.log("getAndroidWalletPass result===", result);
                if(result.data){
                    setUrlAndroidWallet(result.data);
                }else{
                    showAlert(true, t('file_pkpass_not_found'), t('mobile_pass_card'));
                }
            }
        } catch (error) {
            showAlert(true, t('EXCEPTION_PROCESS'), t('ERROR'));
        }
        onShowLoading(false);
    }
    const getGooglePass = async() =>{
        onShowLoading(true);
        try {
            var result = await crmservices.contacts.getGooglePass();
            if (result.code === 'OK') {
                console.log("getGooglePass result===", result);
                if(result && result.data){
                    setUrlGooglePay(result.data);
                }
            }
        } catch (error) {
            showAlert(true, t('EXCEPTION_PROCESS'), t('ERROR'));
        }
        onShowLoading(false);
    }
    return (
        <div>
            <ModalAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                message={error.message}
                error={error.status}
                title={error.title}
            />
            <Loading showLoading={showLoading} />
            <MobilePassCardView 
                open={props.open}
                urlGooglePay={urlGooglePay}
                urlAppleWallet={urlAppleWallet}
                urlAndroidWallet={urlAndroidWallet}
                onClose = {props.onClose}
                getApplePass={getApplePass}
                getAndroidWalletPass={getAndroidWalletPass}
                getGooglePass={getGooglePass}
            />
                
        </div>
    );
}

export default MobilePassCardController;